import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { Provider, EnvironmentProviders, ENVIRONMENT_INITIALIZER, inject } from "@angular/core";
import { AuthService } from "./auth.service";
import { authInterceptor } from "./auth.interceptor";

export const provideAuth = (): Array<Provider | EnvironmentProviders> =>
    {
        return [
            provideHttpClient(withInterceptors([authInterceptor])),
            {
                provide : ENVIRONMENT_INITIALIZER,
                useValue: () => inject(AuthService),
                multi   : true,
            },
        ];
    };